module.exports = __webpack_public_path__ + "static/media/roma-2.ad868910.jpeg";